// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__R3Jf6","smallText":"Footer_smallText__Mlu15","footerText":"Footer_footerText__15f5F"};